import { toast } from "react-toastify";
import baseAPI from "../api/baseApi";
import {
  authHeader,
  authHeaderWithImage,
  languageHeader,
} from "../helpers/authHeader";

const login = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("email", data.email);
    formdata.append("password", data.password);
    formdata.append("device_type", data.device_type);
    formdata.append("device_token", data.device_token);
    // formdata.append("user_type", "2");

    const res = await baseAPI.post(`user-login`, formdata, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const register = async (data) => {
  // try {
  const formdata = new FormData();

  // Merchant Info
  formdata.append("name", data.fullName);
  formdata.append("company_name", data.companyName);
  formdata.append("email", data.email);
  formdata.append("mobile_number", data.mobileNumber);
  if (Array.isArray(data.category)) {
    data.category.forEach((categoryId, index) => {
      formdata.append(`category_id[${index}]`, categoryId);
    });
  } else {
    formdata.append("category_id", data.category);
  }
  formdata.append("password", data.password);

  // National Address
  formdata.append("short_address", data.short_address);
  formdata.append("building_no", data.buildingNo);
  formdata.append("street", data.street);
  formdata.append("longitude", data.longitude);
  formdata.append("latitude", data.latitude);
  formdata.append("secondary_no", data.secondaryNo);
  formdata.append("district", data.district);
  formdata.append("postal_code", data.postalCode);
  formdata.append("national_address", data.nationalAddress);
  formdata.append(
    "national_address_attachment",
    data.nationalAdrressAttachment
  );

  // Merchant Info.
  formdata.append(
    "commercial_registration_number",
    data.commercialRegistrationNumber
  );
  formdata.append(
    "commercial_registration_number_attachment",
    data.commercialRegistrationNumberAttachment
  );
  formdata.append("tax_identification_number", data.taxIdentifictionNumber);
  formdata.append(
    "tax_identification_number_attachment",
    data.taxIdentifictionNumberAttachment
  );

  // Bank Details
  formdata.append("beneficiary_number", data.beneficiaryName);
  formdata.append("bank_name", data.bankName);
  // formdata.append("account_number", data.accountNumber);
  formdata.append("iban_number", data.ibanNumber);
  formdata.append("iban_number_attachment", data.ibanNumberAttachment);

  // Logo And Banner Image

  formdata.append("profile_image", data.logo);
  formdata.append("banner_image", data.bannerImage);

  const res = await baseAPI.post(`merchant-register`, formdata, {
    headers: authHeaderWithImage(),
  });
  return res;
  // } catch (error) {
  //   console.log(error);
  // }
};

const forgotPassword = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("mobile_number", data.email);

    const res = await baseAPI.post(`forgot-password`, formdata, {
      headers: languageHeader(),
    });
    if (res.status == 200) {
      toast.success(res?.data?.message);
      return res.data;
    } else {
      console.log(res);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

const otpVerify = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("otp", data.otp);
    formdata.append("mobile_number", data.email);

    const res = await baseAPI.post(`verify-otp`, formdata, {
      headers: languageHeader(),
    });

    if (res.status == 200) {
      toast.success(res?.data?.message);
      return res.data;
    } else {
      console.log(res);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

const resetPassword = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("password", data.password);
    formdata.append("mobile_number", data.email);

    const res = await baseAPI.post(`reset-password`, formdata, {
      headers: languageHeader(),
    });

    return res;
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

const changePassword = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("old_password", data.old_password);
    formdata.append("new_password", data.new_password);

    const res = await baseAPI.post(`change-password`, formdata, {
      headers: authHeader(),
    });

    return res;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const resendOTP = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("mobile_number", data.mobile_number);

    const res = await baseAPI.post(`resend-otp`, formdata, {
      headers: languageHeader(),
    });

    return res;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const checkEmailAndMobileNumber = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("email", data.email);
    formdata.append("mobile_number", data.mobile_number);
    // formdata.append("user_type", "2");

    const res = await baseAPI.post(`check-email-phone`, formdata, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log("error", error);
    toast.error(error?.response?.data?.message);
  }
};

const AuthService = {
  login,
  register,
  forgotPassword,
  otpVerify,
  resetPassword,
  changePassword,
  resendOTP,
  checkEmailAndMobileNumber,
};
export default AuthService;
